import { Api } from "../config/request";

export default {
  getQcDetails(FeId) {
    return Api.get(`/qc/${FeId}`);
  },
  getQcAdditionalData(payload) {
    return Api.get("/qc/additional-data");
  },
  saveQcDetails(id, payload) {
    return Api.put(`/qc/${id}`, payload);
  },
  approveQcDetails(FeId, payload) {
    return Api.put(`/qc/${FeId}/qc-status`, payload);
  },
  updateQcField(FeId, payload) {
    return Api.put(`/qc/${FeId}/driver-detail`, payload);
  },
};
